import { render, staticRenderFns } from "./SolicitaRevisaoConteudo.vue?vue&type=template&id=a9b873d6&scoped=true"
import script from "./SolicitaRevisaoConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitaRevisaoConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SolicitaRevisaoConteudo.vue?vue&type=style&index=0&id=a9b873d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b873d6",
  null
  
)

export default component.exports